export default __webpack_public_path__ + "static/media/doddles.6094ccf3.png";